import { getUserAgentLanguage } from './language';

// Date time being something like "2019-01-19T15:09:44.000Z"
export const dateTimeToDate = (dateTime: string): string =>
  new Date(dateTime).toLocaleDateString(getUserAgentLanguage());

const MS_IN_SEC = 1000;

export const getSecondsSinceEpoch = (): number => Math.round(Date.now() / MS_IN_SEC);
